document.documentElement.classList.remove('no-js');
(function(){
  const details = document.querySelectorAll('.faq-item');
  details.forEach((item)=>item.addEventListener('toggle',()=>{
    if(item.open){ details.forEach((other)=>{ if(other!==item) other.open=false; }); }
  }));
})();



/* KSS Hybrid homepage motion */
(function(){
  const loader = document.querySelector('[data-archive-loader]');
  if (loader) {
    let seen = false;
    try { seen = sessionStorage.getItem('kssArchiveIntroSeen') === '1'; } catch(e) {}
    const hideLoader = function(){
      loader.classList.add('is-hidden');
      try { sessionStorage.setItem('kssArchiveIntroSeen', '1'); } catch(e) {}
    };
    if (seen || window.matchMedia('(prefers-reduced-motion: reduce)').matches) hideLoader();
    else if (document.readyState === 'complete') window.setTimeout(hideLoader, 120);
    else window.addEventListener('load', function(){ window.setTimeout(hideLoader, 120); }, { once: true });
    window.setTimeout(hideLoader, 900);
  }
  const reveals = document.querySelectorAll('.template-index .reveal');
  if ('IntersectionObserver' in window && reveals.length) {
    const io = new IntersectionObserver(function(entries){
      entries.forEach(function(entry){ if (entry.isIntersecting) entry.target.classList.add('is-visible'); });
    }, { threshold: 0.12 });
    reveals.forEach(function(el){ io.observe(el); });
  } else {
    reveals.forEach(function(el){ el.classList.add('is-visible'); });
  }
  if (window.matchMedia('(pointer:fine)').matches) {
    let mouseFrame = 0;
    document.addEventListener('mousemove', function(event){
      if (mouseFrame) return;
      mouseFrame = requestAnimationFrame(function(){
        document.documentElement.style.setProperty('--mx', event.clientX + 'px');
        document.documentElement.style.setProperty('--my', event.clientY + 'px');
        mouseFrame = 0;
      });
    }, { passive: true });
  }
})();


/* KSS local wishlist: lightweight browser-saved collector list */
(function(){
  const KEY = 'kssWishlistV1';
  const read = () => {
    try {
      const parsed = JSON.parse(localStorage.getItem(KEY) || '[]');
      return Array.isArray(parsed) ? parsed.slice(0, 80) : [];
    } catch(e) { return []; }
  };
  const write = (items) => { try { localStorage.setItem(KEY, JSON.stringify(items.slice(0, 80))); } catch(e) {} };
  const normalizeItem = (button) => ({
    id: String(button.dataset.wishlistId || ''),
    title: button.dataset.wishlistTitle || 'Saved product',
    url: button.dataset.wishlistUrl || '#',
    image: button.dataset.wishlistImage || '',
    price: button.dataset.wishlistPrice || ''
  });
  const getItemId = (button) => String(button.dataset.wishlistId || '');
  const findById = (items, id) => items.some((item) => String(item.id) === String(id));

  const itemMarkup = (item) => `
    <article class="kss-wishlist-item" data-wishlist-item="${escapeHtml(item.id)}">
      ${item.image ? `<img src="${safeUrl(item.image, '')}" alt="${escapeHtml(item.title)}" loading="lazy" decoding="async">` : '<div class="kss-wishlist-item__placeholder"></div>'}
      <div>
        <h3>${escapeHtml(item.title)}</h3>
        ${item.price ? `<p>${escapeHtml(item.price)}</p>` : ''}
        <div class="kss-wishlist-item__actions">
          <a class="kss-wishlist-item__view" href="${safeUrl(item.url, '#')}">View item <span aria-hidden="true">↗</span></a>
          <button class="kss-wishlist-item__remove" type="button" data-wishlist-remove="${escapeHtml(item.id)}">Remove</button>
        </div>
      </div>
    </article>`;

  function escapeHtml(value){
    return String(value || '').replace(/[&<>'"]/g, function(char){
      return {'&':'&amp;','<':'&lt;','>':'&gt;',"'":'&#39;','"':'&quot;'}[char];
    });
  }

  function safeUrl(value, fallback){
    try {
      const parsed = new URL(String(value || ''), window.location.origin);
      if (parsed.protocol !== 'http:' && parsed.protocol !== 'https:') return fallback || '#';
      return escapeHtml(parsed.href);
    } catch(e) { return fallback || '#'; }
  }

  function updateButtons(items){
    document.querySelectorAll('[data-wishlist-toggle]').forEach((button) => {
      const saved = findById(items, getItemId(button));
      button.classList.toggle('is-saved', saved);
      const label = button.querySelector('[data-wishlist-label]');
      if (label) label.textContent = saved ? 'Saved to wishlist' : (button.classList.contains('kss-wishlist-product') ? 'Save to wishlist' : 'Save to wishlist');
      button.setAttribute('aria-pressed', saved ? 'true' : 'false');
    });
  }

  function render(){
    const items = read();
    document.querySelectorAll('[data-wishlist-count]').forEach((node) => node.textContent = String(items.length));
    updateButtons(items);

    const markup = items.map(itemMarkup).join('');
    document.querySelectorAll('[data-wishlist-list], [data-wishlist-page-list]').forEach((list) => {
      list.innerHTML = markup;
      list.hidden = items.length === 0;
    });
    document.querySelectorAll('[data-wishlist-empty], [data-wishlist-page-empty]').forEach((empty) => {
      empty.hidden = items.length > 0;
    });
  }

  let wishlistReturnFocus = null;

  function openDrawer(){
    const shell = document.querySelector('[data-wishlist-shell]');
    if (!shell) return;

    wishlistReturnFocus = document.activeElement;
    render();
    shell.hidden = false;
    shell.setAttribute('aria-hidden', 'false');
    window.requestAnimationFrame(function(){
      shell.classList.add('is-open');
      document.documentElement.classList.add('wishlist-open');
      const closeButton = shell.querySelector('[data-wishlist-close]');
      if (closeButton) closeButton.focus({ preventScroll: true });
    });
  }

  function closeDrawer(){
    const shell = document.querySelector('[data-wishlist-shell]');
    if (!shell) return;

    shell.classList.remove('is-open');
    document.documentElement.classList.remove('wishlist-open');

    window.setTimeout(function(){
      if (!shell.classList.contains('is-open')) {
        shell.hidden = true;
        shell.setAttribute('aria-hidden', 'true');
        if (wishlistReturnFocus && wishlistReturnFocus.focus) wishlistReturnFocus.focus({ preventScroll: true });
      }
    }, 260);
  }

  document.addEventListener('click', function(event){
    const toggle = event.target.closest('[data-wishlist-toggle]');
    if (toggle) {
      event.preventDefault();
      const item = normalizeItem(toggle);
      if (!item.id) return;
      let items = read();
      if (findById(items, item.id)) items = items.filter((saved) => String(saved.id) !== String(item.id));
      else items.unshift(item);
      write(items);
      render();
      return;
    }

    if (event.target.closest('[data-wishlist-open]')) {
      event.preventDefault();
      openDrawer();
      return;
    }

    if (event.target.closest('[data-wishlist-close]')) {
      event.preventDefault();
      closeDrawer();
      return;
    }

    const remove = event.target.closest('[data-wishlist-remove]');
    if (remove) {
      event.preventDefault();
      const id = String(remove.dataset.wishlistRemove || '');
      write(read().filter((item) => String(item.id) !== id));
      render();
      return;
    }

    if (event.target.closest('[data-wishlist-clear]')) {
      event.preventDefault();
      write([]);
      render();
    }
  });

  document.addEventListener('keydown', function(event){
    if (event.key === 'Escape') closeDrawer();
  });

  document.addEventListener('DOMContentLoaded', render);
  render();
})();

/* KSS header popovers, localization controls, mobile search, and UX helpers */
(function(){
  const overlay = document.querySelector('[data-kss-popover-overlay]');
  const scrollTopButtons = Array.from(document.querySelectorAll('[data-kss-scroll-top]'));
  let closeTimer = null;

  function syncScrollTopButtons(){
    const threshold = Math.max(420, window.innerHeight * 0.65);
    const visible = window.scrollY > threshold;
    scrollTopButtons.forEach(function(button){
      button.classList.toggle('is-visible', visible);
      button.setAttribute('aria-hidden', visible ? 'false' : 'true');
      button.tabIndex = visible ? 0 : -1;
    });
  }

  function activePanels(){
    return Array.from(document.querySelectorAll('[data-kss-popover-panel]')).filter((panel) => !panel.hidden);
  }

  function setOverlay(visible){
    if (!overlay) return;
    clearTimeout(closeTimer);
    if (visible) {
      overlay.hidden = false;
      requestAnimationFrame(() => overlay.classList.add('is-visible'));
      document.documentElement.classList.add('kss-popover-open');
    } else {
      overlay.classList.remove('is-visible');
      document.documentElement.classList.remove('kss-popover-open');
      closeTimer = setTimeout(() => {
        if (!activePanels().length) overlay.hidden = true;
      }, 190);
    }
  }

  function closePanel(panel){
    if (!panel || panel.hidden) return;
    panel.classList.remove('is-open');
    const wrap = panel.closest('.header-popover-wrap');
    const trigger = wrap && wrap.querySelector('[data-kss-popover-toggle]');
    if (trigger) trigger.setAttribute('aria-expanded', 'false');
    setTimeout(() => { panel.hidden = true; setOverlay(activePanels().length > 0); }, 170);
  }

  function closePopovers(exceptWrap){
    document.querySelectorAll('[data-kss-popover-panel]').forEach(function(panel){
      const wrap = panel.closest('.header-popover-wrap');
      if (exceptWrap && wrap === exceptWrap) return;
      closePanel(panel);
    });
    if (!exceptWrap) setOverlay(false);
  }

  function openPanel(panel, trigger){
    if (!panel) return;
    panel.hidden = false;
    requestAnimationFrame(() => panel.classList.add('is-open'));
    if (trigger) trigger.setAttribute('aria-expanded', 'true');
    setOverlay(true);
    const focusTarget = panel.querySelector('[data-kss-popover-close], input, select, button, a');
    if (focusTarget) setTimeout(() => focusTarget.focus({ preventScroll: true }), 80);
  }

  function openModal(name){
    const modal = document.querySelector('[data-kss-modal="' + name + '"]');
    if (!modal) return;
    modal.hidden = false;
    document.documentElement.classList.add('kss-modal-open');
    const input = modal.querySelector('input, select, textarea, button');
    if (input) setTimeout(function(){ input.focus(); }, 80);
  }

  function closeModals(){
    document.querySelectorAll('[data-kss-modal]').forEach(function(modal){ modal.hidden = true; });
    document.documentElement.classList.remove('kss-modal-open');
  }

  document.addEventListener('click', function(event){
    const popoverTrigger = event.target.closest('[data-kss-popover-toggle]');
    if (popoverTrigger) {
      event.preventDefault();
      const wrap = popoverTrigger.closest('.header-popover-wrap');
      const panel = wrap && wrap.querySelector('[data-kss-popover-panel]');
      if (!panel) return;
      const willOpen = panel.hidden;
      closePopovers(wrap);
      if (willOpen) openPanel(panel, popoverTrigger);
      else closePanel(panel);
      return;
    }

    if (event.target.closest('[data-kss-popover-close]')) {
      event.preventDefault();
      const panel = event.target.closest('[data-kss-popover-panel]');
      closePanel(panel);
      return;
    }

    if (event.target.closest('[data-kss-popover-overlay]')) {
      event.preventDefault();
      event.stopPropagation();
      closePopovers();
      closeModals();
      return;
    }

    if (!event.target.closest('.header-popover-wrap') && !event.target.closest('[data-kss-popover-panel]')) {
      closePopovers();
    }

    const modalOpen = event.target.closest('[data-kss-modal-open]');
    if (modalOpen) {
      event.preventDefault();
      openModal(modalOpen.dataset.kssModalOpen);
      return;
    }

    if (event.target.closest('[data-kss-modal-close]')) {
      event.preventDefault();
      closeModals();
      return;
    }

    const scrollTop = event.target.closest('[data-kss-scroll-top]');
    if (scrollTop) {
      event.preventDefault();
      window.scrollTo({ top: 0, behavior: 'smooth' });
    }
  });

  document.querySelectorAll('[data-kss-header-search]').forEach(function(form){
    const input = form.querySelector('input[name="q"]');
    form.addEventListener('submit', function(event){
      if (!input || !input.value.trim()) {
        event.preventDefault();
        if (input) input.focus();
      }
    });
  });

  document.addEventListener('keydown', function(event){
    if (event.key === 'Escape') {
      closePopovers();
      closeModals();
    }
  });

  window.addEventListener('scroll', syncScrollTopButtons, { passive: true });
  window.addEventListener('resize', syncScrollTopButtons);
  syncScrollTopButtons();
})();

/* KSS mobile collection grid toggle */
(function(){
  const STORAGE_KEY = 'kssCollectionMobileGrid';
  document.querySelectorAll('[data-collection-section]').forEach(function(section){
    const buttons = Array.from(section.querySelectorAll('[data-grid-view]'));
    if (!buttons.length) return;

    const apply = function(mode){
      const safeMode = mode === 'one' ? 'one' : 'two';
      section.dataset.mobileGrid = safeMode;
      buttons.forEach(function(button){
        const active = button.dataset.gridView === safeMode;
        button.classList.toggle('is-active', active);
        button.setAttribute('aria-pressed', active ? 'true' : 'false');
      });
      try { localStorage.setItem(STORAGE_KEY, safeMode); } catch(e) {}
    };

    let saved = 'two';
    try { saved = localStorage.getItem(STORAGE_KEY) || 'two'; } catch(e) {}
    apply(saved);

    buttons.forEach(function(button){
      button.addEventListener('click', function(){ apply(button.dataset.gridView); });
    });
  });
})();

/* KSS draggable mobile scroll helper */
(function(){
  const control = document.querySelector('[data-kss-scroll-control]');
  const thumb = document.querySelector('[data-kss-scroll-thumb]');
  if (!control || !thumb) return;

  let dragging = false;
  let startY = 0;
  let startScroll = 0;

  const maxScroll = () => Math.max(1, document.documentElement.scrollHeight - window.innerHeight);
  const maxThumb = () => Math.max(1, control.clientHeight - thumb.offsetHeight);

  function updateThumb(){
    if (dragging) return;
    const progress = window.scrollY / maxScroll();
    const y = Math.max(0, Math.min(maxThumb(), progress * maxThumb()));
    thumb.style.transform = 'translate(-50%, ' + y + 'px)';
    const shouldShow = maxScroll() >= 240 && window.scrollY > Math.max(520, window.innerHeight * 0.7);
    control.hidden = !shouldShow;
    control.classList.toggle('is-visible', shouldShow);
  }

  function dragTo(clientY){
    const dy = clientY - startY;
    const scroll = startScroll + (dy / maxThumb()) * maxScroll();
    window.scrollTo(0, Math.max(0, Math.min(maxScroll(), scroll)));
  }

  thumb.addEventListener('pointerdown', function(event){
    dragging = true;
    startY = event.clientY;
    startScroll = window.scrollY;
    thumb.setPointerCapture(event.pointerId);
    event.preventDefault();
  });

  thumb.addEventListener('pointermove', function(event){
    if (!dragging) return;
    dragTo(event.clientY);
  });

  thumb.addEventListener('pointerup', function(event){
    dragging = false;
    try { thumb.releasePointerCapture(event.pointerId); } catch(e) {}
    updateThumb();
  });

  window.addEventListener('scroll', updateThumb, { passive: true });
  window.addEventListener('resize', updateThumb);
  document.addEventListener('DOMContentLoaded', updateThumb);
  updateThumb();
})();
